import useCurrentUser from '#hooks/store/useCurrentUser'
import Api from '#services/api'
import toolAusbildungsNachweisSort from 'ag-common/tools/ausbildungsNachweisSort'
import toolGetFormattedDateRange from 'ag-common/tools/nachweisDateRangeFormatter'
import nachweisNumber from 'ag-common/tools/nachweisNumber'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import actions from 'redux-auto'
import NachweisListe from './NachweisListe'
import NachweisListeAzubiHeader from './NachweisListeAzubiHeader'

export default function NachweisListeAzubi(props) {
  const [nachweise, setNachweise] = useState([])
  const [archivedNachweise, setArchivedNachweise] = useState([])

  const currentUser = useCurrentUser()

  function addDateRange(nachweise) {
    if (!nachweise || nachweise.length === 0) {
      return []
    }
    return nachweise.map(nachweis => {
      return {
        ...nachweis,
        dateRange: toolGetFormattedDateRange.getFormattedDateRange(nachweis, currentUser),
      }
    })
  }

  useEffect(() => {
    try {
      const fetchNachweise = async () => {
        const result = await Api.readNachweisList()
        const nachweise = result[0].ausbildungsnachweise
        const archivedNachweiseResult = await Api.getArchivedAusbildungsnachweise()
        setNachweise(nachweise)
        setArchivedNachweise(archivedNachweiseResult)
      }
      fetchNachweise()
    } catch (e) {
      actions.error.writeError({error: e})
    }
  }, [])

  let nachweiseToBeShown = props.showArchivedAusbildungsnachweise ? archivedNachweise : nachweise
  nachweiseToBeShown = toolAusbildungsNachweisSort.ausbildungsNachweisSort(
    addDateRange(nachweiseToBeShown.slice()),
    false,
  )
  const highestNachweisNummer = nachweiseToBeShown ? nachweisNumber.getHighestNumber(nachweiseToBeShown) : 0
  const hasArchivedNachweise = archivedNachweise ? archivedNachweise.length !== 0 : false
  return (
    <div className="nachweisliste nachweisliste--editor row" data-testid="nachweisliste-azubi">
      <NachweisListeAzubiHeader
        maxNachweisNumber={highestNachweisNummer}
        showLinkToOtherAusbildungsnachweise={hasArchivedNachweise}
        showArchivedAusbildungsnachweise={props.showArchivedAusbildungsnachweise}
      />

      {nachweise && <NachweisListe ausbildungsnachweise={nachweiseToBeShown} canVerify={false} />}
    </div>
  )
}
NachweisListeAzubi.propTypes = {
  showArchivedAusbildungsnachweise: PropTypes.bool,
}
